module.exports = __webpack_public_path__ + "static/img/penyan_logo.e348e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/penyan_logo.png
// module id = jp/1
// module chunks = 5